import { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';
import { useSourceIndeedContract } from '@/hooks/use-source-indeed-contract';

import { IndeedConnectReturn } from '../contracts/indeed-connect-return';
import { useIndeedConnectToasts } from '../contracts/indeed-connect-toasts';
import { IndeedPanelHost } from '../contracts/indeed-panel';

import { IntegratedChannels } from './integrated';
import { NonIntegratedChannels } from './non-integrated';

export function ChannelSettings() {
  const indeedEnabled = useSourceIndeedContract();
  return (
    <div className="mt-4 flex flex-col gap-6">
      {/* Title and description */}
      <div className="flex flex-col gap-1">
        <Typography variant="h4" as="h1">
          <FormattedMessage
            defaultMessage="Sourcing Channels"
            description="Title of the channel settings page"
          />
        </Typography>
        <Typography variant="body1">
          <FormattedMessage
            defaultMessage="Manage and configure the channels used to source and track applicants."
            description="Description of the channel settings page"
          />
        </Typography>
      </div>

      {/* Integrated channels */}
      <Suspense fallback={<IntegratedChannels.Skeleton />}>
        <IntegratedChannels />
      </Suspense>

      {/* Non-integrated channels */}
      <Suspense fallback={<NonIntegratedChannels.Skeleton />}>
        <NonIntegratedChannels />
      </Suspense>
      {indeedEnabled && <IndeedChannelSettings />}
    </div>
  );
}

function IndeedChannelSettings() {
  const indeedConnectToasts = useIndeedConnectToasts();
  return (
    <>
      <IndeedPanelHost />
      <IndeedConnectReturn onOutcome={indeedConnectToasts} />
    </>
  );
}
